import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../StateProvider'
import { InputMasked } from '../../../ui'
import { isValidDate } from '..'
import { convertToClientDate, convertToServerDate } from '../../utils/utils'
import { getUserValue } from '../utils'
import { EMPLOYMENT_ID, RTL_LANGUAGES } from '../../../constants/constants'

/**
 * @param {string} value
 * @returns {boolean}
 */
const isEmploymentDateValid = (value) => {
  const date = new Date(convertToServerDate(value))
  const today = new Date()
  const min = new Date(today.getFullYear() - 100, today.getMonth(), 1)
  const max = today
  today.setHours(0, 0, 0, 0)
  return value.indexOf('_') === -1 && isValidDate(date) && date <= max && date >= min
}

const ExternalLastDateOfEmployment = ({ i18nLabel, name }) => {
  const { i18n, t } = useTranslation()
  const label = i18nLabel ? t(`generatedField.${i18nLabel}`) : ''
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(null)
  const [isFilled, setIsFilled] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [error, setError] = useState('')
  const [{ form: { accId }, form, user }, dispatch] = useStore()
  const { isEmployed, employmentSituationId } = form[accId]
  const userValue = getUserValue(accId, user, name)

  useEffect(() => {
    if (employmentSituationId === EMPLOYMENT_ID.UNEMPLOYED || employmentSituationId === EMPLOYMENT_ID.RETIRED) {
      setIsVisible(true)
      dispatch({ type: 'setValidationFld', name, value: isValid })
    } else {
      setIsVisible(false)
      setValue('')
      setIsValid(false)
      setIsFilled(false)
      dispatch({ type: 'removeFieldValue', name })
      dispatch({ type: 'removeValidationFld', name })
    }
  }, [employmentSituationId, isValid, name])

  /**
   * @param {string} value
   */
  const presetValue = (value) => {
    const clientFormatDate = convertToClientDate(value)
    setValue(clientFormatDate)
    const isValid = isEmploymentDateValid(clientFormatDate)
    setIsValid(isValid)
    setError(!isFilled || isValid ? '' : 'generatedField.invalidLastEmploymentDate')
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  useEffect(() => {
    if (userValue && userValue.length && isEmployed === false) {
      presetValue(userValue)
    }
  }, [userValue, isEmployed, name])

  const onChange = ({ target: { value } }) => {
    setValue(value)
    !value.trim() ? setIsFilled(false) : setIsFilled(true)
  }

  const onBlur = ({ target: { value } }) => {
    const isValid = isEmploymentDateValid(value)
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value: convertToServerDate(value) })
    dispatch({ type: 'setValidationFld', name, value: isValid })
    setError(!isFilled || isValid ? '' : 'generatedField.invalidLastEmploymentDate')
  }

  return isVisible ? (
    <InputMasked
      name={name}
      label={label}
      value={value}
      key={name}
      onBlur={onBlur}
      onChange={onChange}
      valid={isValid}
      error={t(error)}
      type='text'
      mask={[/[0-9]/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]}
      placeholder={RTL_LANGUAGES.includes(i18n?.language) ? 'YYYY.MM.DD' : 'DD.MM.YYYY'}
    />) : null
}

const getExternalLastDateOfEmployment = dateField => {
  const { i18n, name, required, type, order } = dateField
  return (
    <ExternalLastDateOfEmployment
      i18nLabel={i18n}
      name={name}
      required={required}
      type={type}
      key={name}
      order={order}
    />
  )
}

export { ExternalLastDateOfEmployment, getExternalLastDateOfEmployment }
